import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import popupMessage from "../../../services/popupMessage";
import imageUpload from "../../../services/upload";
import { IMAGE_PATH, instanceToken } from "../../../utils/constant";
import {
  EditPageLayout,
  EditFieldLabel,
  EditFormTopSection,
  EditImageSection,
} from "../../../components/edit/EditPageLayout";

const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];

export default function CreatePopupMessage({ homeAlert }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({ title: "" });
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    const path = IMAGE_PATH + result?.imageName;
    setImageFileUrl(result?.imageUploadUrl);
    setValues((prev) => ({
      ...prev,
      image_url: path,
    }));
  }

  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const img = e.target.files[0];
      if (!imgFileTypes.includes(img.type)) {
        setErrors({
          image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
        });
        return;
      }
      if (img.size > 204800) {
        setErrors({
          image_url: "Image file size must be smaller than 200KB.",
        });
        return;
      }
      setImageFile(img);
      setImagePreview(URL.createObjectURL(img));
      setErrors({});
      getImageUrl(img);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", values.title || "");
    formData.append("image_url", values.image_url || "");

    try {
      setLoading(true);
      await imageUpload.uploadImage(imageFileUrl, imageFile);
      await popupMessage.create(instanceToken.token, formData);
      homeAlert("Popup has been created.", false);
      navigate("/popup-messages");
    } catch (error) {
      console.log(error);
      homeAlert("File Upload Failed!", true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EditPageLayout
      title="Create Popup Message"
      subtitle="Add popup image and optional title."
      breadcrumbs={[
        { label: "Popup Messages", path: "/popup-messages" },
        { label: "Create" },
      ]}
      listPath="/popup-messages"
      loading={loading}
      submitLabel="Create"
      onSubmit={handleCreate}
    >
      <EditFormTopSection
        image={
          <EditImageSection
            inputId="create-popup-image"
            imagePreview={imagePreview}
            onFileChange={changeFile}
            error={errors.image_url}
            recommendedSize="1920 × 1080 px, 16:9 aspect ratio, max 200KB"
            accept="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
          />
        }
      >
        <div>
          <EditFieldLabel>Title (optional)</EditFieldLabel>
          <TextField
            fullWidth
            value={values.title || ""}
            onChange={(e) =>
              setValues({ ...values, title: e.target.value.trim() })
            }
            error={!!errors.title}
            helperText={errors.title}
          />
        </div>
      </EditFormTopSection>
    </EditPageLayout>
  );
}
